import { z } from 'zod'

export const syncUpdateSchema = z.object({
  planId: z.string().uuid(),
  deviceId: z.string(),
  timestamp: z.number()
})

export const presenceUpdateSchema = z.object({
  cursor: z.object({
    lat: z.number(),
    lng: z.number()
  }).optional(),
  deviceId: z.string(),
  timestamp: z.number()
})
